import { useParams } from 'react-router'

import type { AnnulOperationRouteParams } from '../../system/types'

export const useAnnulOperationKey = (): string => {
  const { annulOperationKey } = useParams<AnnulOperationRouteParams>()

  if (!annulOperationKey) {
    throw new Error(`No annul operation key was found`)
  }

  return annulOperationKey
}
